import { RouteRecordRaw } from 'vue-router';

const technologyRoutes: RouteRecordRaw[] = [
  {
    path: '/technology/documents',
    name: 'technology-documents',
    component: () =>
      import(/* webpackChunkName: "technology-documents" */ '@/views/technology/DocumentsView.vue'),
    meta: {
      title: 'Documents Technology',
      requiresAuth: false,
    },
  },
  {
    path: '/technology/luxury_items',
    name: 'technology-luxury_items',
    component: () =>
      import(/* webpackChunkName: "technology-watches" */ '@/views/technology/LuxuryItemsView.vue'),
    meta: {
      title: 'Luxury Items Technology',
      requiresAuth: false,
    },
  },
  {
    path: '/technology/personnel',
    name: 'technology-personnel',
    component: () =>
      import(/* webpackChunkName: "technology-personell" */ '@/views/technology/PersonnelView.vue'),
    meta: {
      title: 'Personnel Technology',
      requiresAuth: false,
    },
  },
];

export default technologyRoutes;
